export default {"src":"/_next/static/media/reviews-new-call-request.cb3e4026.svg","height":42,"width":338,"blurWidth":0,"blurHeight":0};